module.exports = __webpack_public_path__ + "media/images/avatar_homem-fd25db1c.png";